import { Link } from "react-router-dom";

const NotFound = () => (
  <div
    data-testid="page-404"
    className="min-h-[70vh] flex items-center justify-center bg-background text-center px-5"
  >
    <div>
      <div className="inline-flex items-center justify-center bg-white px-4 py-2 rounded-sm mb-8">
        <img
          src="/brand/rns-logo-wide.png"
          alt="RNS Automobile"
          className="h-14 w-auto object-contain"
        />
      </div>
      <div className="font-display font-black text-7xl md:text-9xl tracking-tighter text-[#C8102E]">
        404
      </div>
      <h1 className="mt-4 font-display font-bold text-2xl uppercase tracking-tight">
        Part not found in inventory
      </h1>
      <p className="mt-3 text-muted-foreground max-w-md mx-auto">
        The page you&apos;re looking for doesn&apos;t exist. Let&apos;s get
        you back on the road.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center h-12 px-6 bg-[#C8102E] text-white text-xs font-bold uppercase tracking-overline hover:bg-[#A00D24] transition-colors duration-200"
      >
        Back to Home
      </Link>
    </div>
  </div>
);

export default NotFound;
